// extracted by mini-css-extract-plugin
export var form = "_d3-0";